// extracted by mini-css-extract-plugin
module.exports = {"info":"_6ff1de1","infoHeader":"_b97ede5"};